<template>
<div>

  <b-container>    
      <b-row>
        <b-col cols="3">  <img  alt="Canem" src="@/assets/images/canem-logo.svg"  height="28px">  </b-col>
        <b-col> <div class="float-right"> <b style="font-size:1.3rem;"> {{project.projectId}} {{ project.description}}</b> </div>  </b-col>
      </b-row>

      <b-row>
        <b-col cols="3">  
          <div> <b style="font-size:1.1rem;"> 
              <span v-if="project.isJournal">Journal</span>
              <span v-else>Site Journal</span> 
            </b> 
          </div> 
        </b-col>
        <b-col>  <div class="float-right"> <b style="font-size:1.1rem;"> {{ data.journalDate | moment("dddd, MMMM Do YYYY") }} </b> </div>   </b-col>
      </b-row>

      <b-row class="my-3">
        <b-col>
          <b-card no-body header-tag="header">
            <template v-slot:header>
              <b>Weather</b>
            </template>

            <div class="p-2 font-smaller" style="min-height:82px;" >
            <b v-if="data.weather">General Conditions:</b> {{data.weather}} 
            <span class="float-right pr-3"> <b v-if="data.temperature">Temp:</b> {{data.temperature}} <span v-if="data.temperature">&#8451;</span> </span>
              <div class="pt-1">{{data.weatherRemarks}}</div>
            </div>

          </b-card>
        </b-col>

      <b-col>
          <b-card no-body header-tag="header">
                  <template v-slot:header>
                    <b>Workforce</b>
                  </template>
                  <div class="p-2 font-smaller" style="min-height:82px;" >

                  <b-table-simple small class="text-center mb-1" style="color:black;">
                    <b-tr>
                      <b-th>Foreman</b-th>
                      <b-th>Journeyman</b-th>
                      <b-th>Apprentice</b-th>
                      <b-th v-if="data.other&&data.other!=0">Other</b-th>
                    </b-tr>
                    <b-tr>
                      <b-td>{{data.foreman}}</b-td>
                      <b-td>{{data.journeyman}}</b-td>
                      <b-td>{{data.apprentice}}</b-td>
                      <b-td v-if="data.other!=0">{{data.other}}</b-td>                  
                    </b-tr>
                  </b-table-simple>
                    
                  {{data.workforceRemarks}}

                  </div>
          </b-card>
      </b-col>     

      </b-row>

      <div v-for="section in data.layout.layoutSections" :key="section.sectionId" >
          
        <b-card no-body header-tag="header" class="my-2" style="min-height:120px;">
          <template v-slot:header>
          <b>{{ section.label }}</b>
          </template>

          <div v-for="item in section.layoutSectionItems" :key="item.itemId" class="p-2 ml-2 font-smaller" >
            <div v-if="hasEntry(item.itemId)"> <b> {{item.label}} </b> </div>

            <div v-for="(entry) in journalEntry(item.itemId)" :key="entry.id" class="p-2 font-smaller" >   
                {{entry.remarks}}   <div v-if="entry.noReport"> ({{item.noReportLabel}}) </div>
            </div>  

          </div>              

        </b-card>

      </div>  
    
    </b-container>
  
    <b-container v-if="includePhotos">  

    <p style="page-break-after: always;">&nbsp;</p>

      <b-card no-body header-tag="header" class="my-2" style="min-height:120px;">
        <template v-slot:header>
          <b>Photos</b>
        </template>
     

      <b-row v-for="item in journalPhotos" :key="item.id" class="m-0 pt-1">
          
            <b-card no-body class="pb-2 pt-2" style="width:900px; border: none; background: none;">
              <b-container class="m-0 p-0">
                <b-row class="m-0">
                  <b-col sm class="m-0 p-1">
                    <div>
                     
                        <b-img :src="'data:image/jpeg;base64,' + item.thumbnail" alt="photo" fluid></b-img>
                     
                    </div>
                    <div class="text-center">
                        <small>{{item.fileName}}</small>
                    </div>
                  </b-col>

                  <b-col sm>
                  <div class="text-left pt-2">
                    <strong>{{ item.caption }}</strong>
                    <div class="p-2" style="white-space: pre-line;">{{item.remarks}}</div>
    
                  </div> 
                  </b-col>
                </b-row>
              </b-container>
            </b-card>
          
          </b-row>
    </b-card>
   
    </b-container>

    <p style="page-break-after: always;">&nbsp;</p>

</div>
</template>

<script>
export default {
  name: "PrintableJournal",
  props: {
      data: Object,
      project: Object,
      includePhotos: Boolean,
      journalPhotos: Array
  },    
 methods: {

    journalEntry(itemId) {
      var result = new Array();
      var entry = this.data.journalEntries.find(e => e.itemId == itemId);

      if (entry){
        result.push(entry);
      }
      else{
        result.push( {id: 0, itemId: itemId, journalPageId: this.data.id, noReport: null, remarks: '' } );
      };

      return result;

    },

    hasEntry(itemId) {

      var entry = this.data.journalEntries.find(e => e.itemId == itemId);
      if (entry){
        return true;
      } 
      else {
        return false;
      }

    }

 }
 
}

</script>



<style scoped>

.font-smaller{
  font-size: .875rem;
}

</style>